/*
 * @Author: shannyHuang
 * @Date: 2022-05-30 14:51:49
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-04-21 10:39:23
 * @FilePath: \wemeet-web-activity\src\utils\activity-type\add-option.ts
 */

// 票务radio
export const CREATE_TICKECT_ARR = [
  {
    value: '1',
    text: '免费',
    message: '观众免费报名参与活动',
  },
  {
    value: '2',
    text: '付费',
    message: '观众需付费参与活动',
  },
  {
    value: '3',
    text: '免费+付费',
    message: '灵活搭配活动门票种类，免费、付费同时支持',
  },
];
export const TICKECT_ARR = [
  {
    value: '1',
    text: '免费',
    message: '观众免费报名参与活动。如需修改门票价格请前往',
  },
  {
    value: '2',
    text: '付费',
    message: '观众需付费参与活动。如需修改门票价格请前往',
  },
  {
    value: '3',
    text: '免费+付费',
    message: '灵活搭配活动门票种类，免费、付费同时支持。如需修改门票价格请前往',
  },
];
export const SCHEDULE_ARR = [
  {
    type: '0',
    label: '单场',
    message: '快速编辑，仅允许添加一场活动日程',
  },
  {
    type: '1',
    label: '多场',
    message: '自定义活动日程及场地，支持多场次混合排列',
  },
];
export const FAST_LIST = [
  {
    type: '0',
    label: '快速创建',
    message: '自动创建一场日程及免费门票',
  },
  {
    type: '1',
    label: '手动创建',
    message: '自定义日程数量及门票类型',
  },
];
export const ACCESS_RULES = [
  {
    type: '1',
    label: '无限制',
    message: '观众无需报名，可直接进入活动，可进入的人数受到版本梯度的最高方数限制',
  },
  {
    type: '0',
    label: '门票报名',
    message: '观众需购票报名，支持付费门票、免费门票',
  },
];
// 是否公开
export const PUBLIC_ARR = [
  {
    type: '1',
    label: '公开',
    message: '所有人可见，发布完成后将公开在个人主页',
  },
  {
    type: '0',
    label: '私密',
    message: '活动将在个人主页上隐藏，仅可通过链接、二维码访问',
  },
];

export const COS_STYLE_NAME = {
  AVATAR: ['avatar_small', 'avatar_middle', 'origin'], // 头像
  BANNER: ['banner_small', 'banner_middle', 'origin'], // banner
  EVENT: ['event_small', 'event_middle', 'origin'], // 活动
};
